import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TextSkeleton } from './text-skeleton';
export var CardSkeleton = function () {
    return (_jsxs("div", { className: 'flex animate-pulse gap-2 px-2', children: [_jsx("div", { className: 'w-8 h-8 bg-vjwSecondary rounded-full' }), _jsx("div", { className: 'w-full', children: _jsx(TextSkeleton, {}) })] }));
};
